import Component from '@glimmer/component';
import TimeZoneIcon from 'ember-wiser/components/icons/time-zone';
import { or } from 'ember-truth-helpers';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    date: Date;
    originalOffsetInSeconds: number;
    tooltipPosition?: string;
  };
  Blocks: {
    default: [];
  };
}

export default class TimezoneWithWarning extends Component<Signature> {
  get dateLocaleOffsetInSeconds(): number {
    return -this.args.date.getTimezoneOffset() * 60;
  }

  get showTooltip(): boolean {
    if (!this.args.originalOffsetInSeconds) {
      return false;
    }

    return this.args.originalOffsetInSeconds !== this.dateLocaleOffsetInSeconds;
  }

  get tooltipLabel(): string | undefined {
    // offset is in seconds, we want to display it in hours
    return `Fuseau horaire différent : UTC${this.offsetInUtc}`;
  }

  get offsetInUtc(): string {
    const offset = this.args.originalOffsetInSeconds / 3600;
    return offset > 0 ? `+${offset}` : offset.toString();
  }

  <template>
    <div class='flex items-center gap-1'>
      {{yield}}
      {{#if this.showTooltip}}
        <div
          data-tooltip={{this.tooltipLabel}}
          data-position={{or @tooltipPosition 'top center'}}
        >
          <TimeZoneIcon />
        </div>
      {{/if}}
    </div>
  </template>
}
